import type { RootState } from '~/redux/store';
import type { SourcePhoneNumber } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getParams = (state: RootState): IRestIndexParams<SourcePhoneNumber> => ({
  sortBy: state.sourcePhoneNumbers.sortBy,
  page: state.sourcePhoneNumbers.page,
  pageSize: state.sourcePhoneNumbers.pageSize,
  with: state.sourcePhoneNumbers.with.join(','),
  ...state.sourcePhoneNumbers.filters,
});

export const getItem = (state: RootState): SourcePhoneNumber | null => state.sourcePhoneNumbers.item;

export const getInitialItem = (state: RootState): string | null => state.sourcePhoneNumbers.initialItem;
